import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { initialState } from '../../store/reducers/app';

// Get the language from the server, or use the initial state from the store.
const lng = window?.INITIAL_STATE?.app?.language || initialState.language;

i18next.use(initReactI18next).init({
  lng,
  fallbackLng: 'en', // use 'en' if detected lng is not available.
  showSupportNotice: false, // hide the Locize promo banner in the console.
  interpolation: {
    escapeValue: false,
  },
  resources: {},
});

export default i18next;
